import script from "./form-podcast.vue?vue&type=script&setup=true&lang=ts"
export * from "./form-podcast.vue?vue&type=script&setup=true&lang=ts"

import "./form-podcast.vue?vue&type=style&index=0&id=8492a198&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8492a198"]])

export default __exports__